export function getErrorMessage(error: unknown, fallback = 'Erro inesperado'): string {
  if (typeof error === 'string') return error;

  if (error instanceof Error) {
    return error.message || fallback;
  }

  if (typeof error === 'object' && error) {
    const maybeMessage = (error as Record<string, unknown>).message;
    if (typeof maybeMessage === 'string' && maybeMessage.trim()) {
      return maybeMessage;
    }
  }

  return fallback;
}
